import { Component } from '@angular/core';

@Component({
  selector: 'app-header-bar-brand',
  template: `
    <div class="navbar-brand">
      <a
        class="navbar-item"
        href="https://mroll.bridgend.wepacloud.eu/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="fab js-logo fa-angular fa-2x" aria-hidden="true"></i>
      </a>
      <a class="navbar-item nav-home" router-link="/">
        <span class="brand-first">MOTHER ROLL - </span>
        <span class="brand-third"> BRIDGEND</span>
      </a>
    </div>
  `,
})
export class HeaderBarBrandComponent {}
